import React from 'react';
import ShopIcon from '../../ShopIcon';

export const ShopIconWithBubble = () => (
  <div className="bg-pear flex h-full w-auto items-center justify-center rounded-full p-2">
    <ShopIcon fillColor="#fff" />
  </div>
);
